import { createAction, props } from '@ngrx/store';
import { ILoanProfileOption, ISimulatorData, ISimulatorModel } from '@partners/api';
import { IRemoteError } from '@partners/errors';

export class SimulatorActions {
  static reset = createAction('[Simulator] Reset State');

  static selectProfileOption = createAction(
    '[Simulator] Select Profile Option',
    props<{ profileOption: ILoanProfileOption }>()
  );

  static unSelectProfileOption = createAction('[Simulator] UnSelect Profile Option');

  static load = createAction('[Simulator] Load');
  static loadSuccess = createAction(
    '[Simulator] Load Success',
    props<{ model: ISimulatorModel; data: ISimulatorData }>()
  );
  static loadFailure = createAction('[Simulator] Load Failure', props<{ error: IRemoteError }>());
  static submit = createAction('[Simulator] Submit');
  static submitSuccess = createAction('[Simulator] Submit Success', props<{ model: ISimulatorModel }>());
  static submitFailure = createAction('[Simulator] Submit Failure', props<{ error: any }>());
}
